// extracted by mini-css-extract-plugin
export var subheaderContainer = "category-module--subheader-container--2xIBj";
export var productsCountText = "category-module--productsCountText--3CiQ6";
export var control = "category-module--control--33m6P";
export var container = "category-module--container--2CYSF";